module.exports = __webpack_public_path__ + "media/toolkits/HVAC-mobile-ecosystem-a69363c4.png";